subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count > 0 ? `\u00a0(${cart.item_count})` : '';
      });
    });
});

if (!customElements.get('mimicri-header')) {
  customElements.define(
    'mimicri-header',
    class MimicriHeader extends HTMLElement {
      connectedCallback() {
        this.hamburger = this.querySelector('.mimicri-header__hamburger');
        this.menu = document.getElementById('MimicriMobileMenu');
        this.closeBtn = this.menu?.querySelector('.mimicri-mobile-menu__close');
        this.menuAccordionTriggers = this.menu?.querySelectorAll('.mimicri-mobile-menu__item-trigger') || [];
        this.menuAccordionItems = this.menu?.querySelectorAll('.mimicri-mobile-menu__item--has-sub') || [];

        this.hamburger?.addEventListener('click', () => this.openMenu());
        this.closeBtn?.addEventListener('click', () => this.closeMenu());
        this.menuAccordionItems.forEach((item) => {
          item.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            this.toggleMobileMenuItem(item.querySelector('.mimicri-mobile-menu__item-trigger'));
          });
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.menu?.getAttribute('aria-hidden') === 'false') {
            this.closeMenu();
          }
        });

        this.menu?.querySelectorAll('a[href*="#"]').forEach((link) => {
          link.addEventListener('click', (e) => {
            const url = new URL(link.href, window.location.origin);
            if (!url.hash) return;
            if (url.pathname === window.location.pathname) {
              e.preventDefault();
              this.closeMenu();
              const target = document.querySelector(url.hash);
              if (target) {
                setTimeout(() => target.scrollIntoView({ behavior: 'smooth' }), 300);
              }
            } else {
              this.closeMenu();
            }
          });
        });
      }

      openMenu() {
        this.menu.setAttribute('aria-hidden', 'false');
        this.hamburger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mimicri-menu-open');
        this.closeBtn?.focus();
      }

      closeMenu() {
        this.menu.setAttribute('aria-hidden', 'true');
        this.hamburger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mimicri-menu-open');
        this.hamburger?.focus();
      }

      toggleMobileMenuItem(btn) {
        const item = btn.closest('.mimicri-mobile-menu__item');
        const content = item?.querySelector('.mimicri-mobile-menu__item-sub');
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        this.menuAccordionTriggers.forEach((trigger) => {
          const currentItem = trigger.closest('.mimicri-mobile-menu__item');
          const panel = currentItem?.querySelector('.mimicri-mobile-menu__item-sub');

          trigger.setAttribute('aria-expanded', 'false');
          currentItem?.classList.remove('is-open');
          panel?.classList.remove('is-open');
          panel?.setAttribute('aria-hidden', 'true');
        });

        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          item?.classList.add('is-open');
          content?.classList.add('is-open');
          content?.setAttribute('aria-hidden', 'false');
        }
      }
    }
  );
}
